import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function collectionCardTemplate(item) {
  let title = item.title;

  // if there is a Public Title set, use that instead
  if (item.meta?.custom?.public_title) {
    title = item.meta.custom.public_title;
  }

  return html`
    <a href="/collections/${item.handle}" class="ac-collection-card">
      ${title}
    </a>
  `;
}